import "core-js/modules/es.regexp.flags";
import { connect } from 'react-redux';
import modal from 'decorators/Modal/Modal';
import { withSagas } from 'decorators/Sagas/Sagas';
import { decorateWith } from 'helpers/decorator';
import { createSubscription, userSubscription } from 'redux/saga/entities/bound';
import { LEAVING_PAGE_FLAG, switchSubscription, watchPlanConfirmationModalSagas } from './PlanConfirmationModal.saga';
import { PlanConfirmationModal } from './PlanConfirmationModal';
export var mapStateToProps = function mapStateToProps(state) {
  return {
    error: createSubscription.error(state),
    subscription: userSubscription.select(state),
    leaving: state.page.flags[LEAVING_PAGE_FLAG]
  };
};
export var mapDispatchToProps = {
  switchSubscription: switchSubscription
};
export var modalConfig = {
  headerClass: 'modal--640 modal__plan-confirmation'
};
export var PlanConfirmationModalContainer = decorateWith(modal(modalConfig), withSagas({
  watch: watchPlanConfirmationModalSagas
}), connect(mapStateToProps, mapDispatchToProps))(PlanConfirmationModal);